import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type ISummaryStyleClasses =
  | 'summaryContainer'
  | 'root'
  | 'containerTitle'
  | 'image'
  | 'newLink'
  | 'expandIcon'
  | 'tradeInCar'
  | 'expanded'
  | 'urlItem'
  | 'selectionContainer'
  | 'selectedFeaturesCategoryTitle'
  | 'selectedFeaturesSubcategoryTitle'
  | 'optionPriceWrapper'
  | 'optionPrice'
  | 'changeAction'
  | 'selectedOptionTitlePrice'
  | 'selectedOptionContainer'
  | 'indicativeNumber'
  | 'linkName'
  | 'sectionTitle'
  | 'selectedOptionLabels';

const summaryStyles = makeStyles<ISpcTheme, ISummaryStyleClasses>(
  theme => ({
    summaryContainer: {
      fontFamily: theme.typography.fontFamily,
      [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        borderRadius: 0,
        border: `1px solid ${theme.palette.text.disabled}`,
        padding: '16px 24px 16px 16px',
      },
    },
    root: {
      borderRadius: '3px',

      [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        borderRadius: 0,
        padding: '16px 24px 16px 16px',
        border: `1px solid ${theme.palette.text.disabled}`,
      },
    },

    containerTitle: {
      minHeight: '56px',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      flexDirection: 'row',

      [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        minHeight: 'unset',
      },
    },
    expanded: {
      borderTop: 0,
    },
    image: {
      width: '100%',
    },
    expandIcon: {
      fontSize: theme.typography.fontXL,
      marginBottom: theme.spacing(-1),
    },
    tradeInCar: {
      position: 'relative',
      top: theme.spacing(-1.2),
    },
    newLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
    urlItem: {
      marginTop: '16px',
    },
    selectionContainer: {
      borderBottom: `1px solid ${theme.palette.primaryDisabled.main}`,
      padding: '8px 0 0',
      display: 'inline-block',
      width: '100%',
      '&:last-child': {
        borderBottom: 0,
      },
    },
    selectedFeaturesCategoryTitle: {
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    selectedFeaturesSubcategoryTitle: {
      fontSize: theme.typography.fontXS,
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    optionPriceWrapper: {
      alignItems: 'center',
      display: 'flex',
      lineHeight: '22px',
      '& span': {
        fontWeight: 700,
      },
    },
    optionPrice: {
      display: 'flex',
      fontSize: theme.typography.fontSM,
      fontWeight: 'bold',
    },
    changeAction: {
      display: 'flex',
      lineHeight: 'initial',
    },
    selectedOptionContainer: {
      margin: '8px 0 16px',
    },
    selectedOptionTitlePrice: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap',
      flexDirection: 'row',
    },
    indicativeNumber: {
      top: 0,
      verticalAlign: 'super',
    },
    linkName: {},
    sectionTitle: {},
    selectedOptionLabels: {},
  }),
  { name: 'Customise_Summary' },
);

export default summaryStyles;
